import {getRequest, postRequest} from '@services/api/axiosHandler'
import store from '@store'
import pageValidation from '@services/validations/pageValidation'
import {getArticles} from '@services/articles/centralHandler'

import Project from '@models/project/Project'
import Configuration from '@models/project/Configuration'

import Building from '@models/building/Building'
import Unit from '@models/building/Unit'
import Room from '@models/building/Room'

import Unitairvolume from '@models/airvolumes/Unitairvolume'
import Roomairvolume from '@models/airvolumes/Roomairvolume'
import Systemselection from '@models/airvolumes/Systemselection'
import Installation from '@models/airvolumes/Installation'
import Valve from '@models/airvolumes/Valve'
import RoomtypesHasOperationmodesHasAirvolume from "@models/helpers/RoomtypesHasOperationmodesHasAirvolume";
import RoomtypesHasLtmsHasOperationmodesHasDevicepackage
  from "@models/helpers/RoomtypesHasLtmsHasOperationmodesHasDevicepackage";

export const pingBackend = async function () {
  try {
    var response = await getRequest('ping')
    if (response.status >= 400) {
      store.dispatch('alert/setAlert', {
        type: 'danger',
        message: Lang('lang.error.session_expired'),
      })
      logout()
      return false
    } else {
      // session
      if (response.data != true) {
        store.dispatch('alert/setAlert', {
          type: 'danger',
          message: Lang('lang.error.session_expired'),
        })
        logout()
        return false
      }

      return true
    }
  } catch (error) {
    store.dispatch('alert/setAlert', {
      type: 'danger',
      message: Lang('lang.error.session_expired'),
    })
    logout()
    return false
  }
}

export const disableSite = function () {
  window.alert(
    'Ihre Sitzung konnte nicht verlängert werden. Sie wurden daher abgemeldet.'
  )
  store.dispatch('session/clearTimer')
}

/*

	'message.logout_failed' => 'Abmelden  fehlgeschlagen',
	'message.login_failed' => 'Anmelden  fehlgeschlagen',
	'message.logout_success' => 'Abmelden  erfolgreich',
	'message.login_success' => 'Anmelden  erfolgreich',




*/

export async function login(credentials) {
  window.enableLoadingAnimation()
  await window.sleep(200)
  setTimeout(async () => {
    try {
      const response = await postRequest('login', credentials)
      if (response.data == true) {
        await getUserData()
        store.dispatch('session/setTimer')
        window.disableLoadingAnimation()

        let user = store.state.session.user

        if (!user.registration_complete) {
          store.dispatch('alert/setAlert', {
            type: 'info',
            message: Lang('lang.kwl.alert.registration_not_complete'),
            time: 9999999
          })
        } else {
          store.dispatch('alert/setAlert', {
            type: 'success',
            message: Lang('lang.message.login_success'),
          })

          // get configuration project
          const configuration = Configuration.query()
            .with(['project'])
            .first()

          // check if project description is empty and user note is not empty, then set user note to project description
          if ((configuration.project.description == null || configuration.project.description == '') && user.note != null) {
            // update project description
            Project.update({
              where: configuration.project.id,
              data: {
                description: user.note
              }
            })
          }
        }
      } else {
        window.disableLoadingAnimation()
        store.dispatch('alert/setAlert', {
          type: 'danger',
          message: Lang('lang.message.login_failed'),
        })
      }
      getArticles('login')
    } catch (error) {
      window.disableLoadingAnimation()
      store.dispatch('alert/setAlert', {
        type: 'danger',
        message: Lang('lang.message.login_failed'),
      })
    }
  }, 200)
}

export async function logout() {
  window.enableLoadingAnimation()
  setTimeout(async () => {
    try {
      getRequest('logout')
      store.dispatch('navigation/setSide', 'Building')
      store.dispatch('session/clearTimer')
      store.dispatch('session/resetState')
      window.disableLoadingAnimation()
      clearSession()
      store.dispatch('alert/setAlert', {
        type: 'success',
        message: Lang('lang.message.logout_success'),
      })
    } catch (error) {
      window.disableLoadingAnimation()
      store.dispatch('alert/setAlert', {
        type: 'danger',
        message: Lang('lang.message.logout_failed'),
      })
    }
  }, 200)
}

export async function getUserData() {
  try {
    var response = await getRequest('user')
    store.state.session.user = response.data.user
    const configuration = Configuration.query()
      .with(['project.contact'])
      .first()
    Project.create({
      data: response.data.projects,
    })
    if (configuration != null) {
      if (
        !(
          configuration.project_id != null &&
          Project.query().where('id', configuration.project_id).exists()
        )
      ) {
        Project.insertOrUpdate({
          data: configuration.project,
        })
      }
    }
  } catch (error) {
    store.state.session.user = {}
  }
}

export async function getAccessToken() {
  try {
    return await getRequest('user/access_token')
  } catch (error) {
  }
}

export async function getRefreshToken() {
  try {
    return await getRequest('user/refresh_token')
  } catch (error) {
  }
}

export function clearSessionForNorm() {

  let units = Unit.query().all();
  units.forEach(unit => {
    Unit.update({
      where: unit.id,
      data: {ventilationMeasure: null}
    });
  });

  Room.deleteAll()
  Unitairvolume.deleteAll()
  Roomairvolume.deleteAll()
  Systemselection.deleteAll()
  Installation.deleteAll()
  Valve.deleteAll()
  RoomtypesHasOperationmodesHasAirvolume.deleteAll()
  RoomtypesHasLtmsHasOperationmodesHasDevicepackage.deleteAll()

  pageValidation.validatePossiblePages()
}

export function clearSession() {
  Building.deleteAll()
  Unit.deleteAll()
  Room.deleteAll()
  Unitairvolume.deleteAll()
  Roomairvolume.deleteAll()
  Systemselection.deleteAll()
  Installation.deleteAll()
  Valve.deleteAll()

  store.dispatch('navigation/resetState')

  Building.create({
    data: {
      units: [{}],
    },
  })
  // get user from store
  const user = store.state.session.user
  let projectdescription = ''
  if (user.note != null) {
    projectdescription = user.note
  }
  Project.insert({
    data: {
      selectedProject: true,
      country: store.state.User.country.country_id,
      description: projectdescription,
      configurations: [
        {
          selectedConfiguration: true,
        },
      ],
    },
    create: ['configurations'],
  })
  pageValidation.validatePossiblePages()
}
